<template>
    <div>
        <ViewDocumentType  v-if="!!item" @success="alertSuccess"></ViewDocumentType>

        <DocumentTypeTable
            title="Users"
            @addHealth="showDocumentTypeModal"
            ref="table"
        ></DocumentTypeTable>
        
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import DocumentTypeTable from './DocumentTypeTable'
import ViewDocumentType from './ViewDocumentType'
// import CreateVehicleForm from './CreateVehicleForm'

export default {
    name: 'Document Type',
    mixins: [popupMixins, permissionsMixins],
    components: {
        DocumentTypeTable,
        ViewDocumentType,
    },
    data: () => {
        return {
            item: null,
        }
    },

    methods: {
        alertSuccess(action) {
            console.log("asdasda",action)
            console.log(this.item)
            this.genericToast(
                this.componentName,
                action,
                'success',
                `${name} has been succcessfully ${action.toLowerCase()}`
            )
            //this.doToast('Success', `Item ${action}!`, 'success')
            this.item = null
            this.$refs.table.doSearch()
        },
        showDocumentTypeModal() {
            this.$refs.createDocumentType.showModal()
        },
        // created() {
        //     this.doToast('Created!', 'Vehicle Created', 'success')
        //     this.$refs.table.doSearch()
        //     this.$refs.createVehicle.hideModal()
        // },
        handleError(error) {
            this.doToast(this.$translate('error'), error.message, 'danger')
        },
    },
}
</script>
<style></style>
